<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/aTaLBa/tc-custom/9781634864312.jpg?1723404654836" alt="This image is the cover for the book Eating Out"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Eating Out
      </h1>
      <p class="bookDescription body article font2">
        <p>When Lara Bennett is called for a job interview, the last person she expects to run into is her old high school sweetheart. She hasn’t seen Meredith in years, having lost touch when they headed off to different colleges. Meeting up with her again after all this time reignites feelings Lara thought long buried.<br/><br/>Meredith Marshall owns Marshall Ad Agency. When she saw Lara’s resume, she hoped it belonged to the girl she first fell in love with as a teen, and she isn’t disappointed when Lara shows up for the interview.<br/><br/>After work, Meredith invites Lara to dinner. Things heat up between them at the restaurant, reminding the women how right they used to be together. Can Lara land the job -- and Meredith’s heart, too?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J.T. Marie
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2c23c30c